import React from 'react';

import NotFoundImage from 'static/no-data.svg';

import MainLayout from 'components/templates/main-layout';
import Typography from 'components/common/typography';

import { ImageContainer, Image } from './elements';

const NotFound = () => (
  <MainLayout>
    <Typography align="center" lg marginT="30" marginB="50">
      Contenido no encontrado
    </Typography>
    <ImageContainer marginAuto>
      <Image src={NotFoundImage} />
    </ImageContainer>
  </MainLayout>
);

export default NotFound;
